<template>
  <dialogModel
    :title="dialogTitle"
    :visible="VisibleEvaluation"
    width="600px"
    :footer="false"
    @handleClose="handleClose"
  >
    <div class="dialog-content">
      <div class="evaluation-content">
        <div class="content-item">
          评价人：{{ data.companyName || companyName }}
        </div>
        <div class="content-item" v-if="data.handleTypeName">
          服务类型：{{ data.handleTypeName }}
        </div>
        <div class="content-item" v-if="data.businessTypeName">
          服务类别：{{ data.businessTypeName }}
        </div>
        <div class="content-item" v-if="evaluationMonth || data.proxyServiceMonth">
          评价月份：{{ evaluationMonth || data.proxyServiceMonth }}
        </div>
        <div class="content-item">
          技术能力：<el-rate v-model="value1" allow-half :disabled="isEvaluated"></el-rate>
        </div>
        <div class="content-item">
          响应速度：<el-rate v-model="value2" allow-half :disabled="isEvaluated"></el-rate>
        </div>
        <div class="content-item">
          服务态度：<el-rate v-model="value3" allow-half :disabled="isEvaluated"></el-rate>
        </div>
        <div class="content-item comment-item">
          <span class="comment-label">评语：</span>
          <div v-if="isEvaluated" class="comment-text">
            {{ commentDisplayText }}
          </div>
          <div v-else class="textarea-box">
            <el-input
              type="textarea"
              class="textarea-lg"
              placeholder="请填写评语"
              v-model="textarea"
              :rows="5"
              maxlength="1500"
              show-word-limit
              resize="none"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!isEvaluated" slot="footer">
      <div class="dialog-model-footer-btns">
        <el-button
          class="dialog-model-btn dialog-model-btn-cancel"
          @click="handleClose"
          >取 消</el-button
        >
        <el-button
          class="dialog-model-btn dialog-model-btn-confirm"
          @click="handelSb"
          >提 交</el-button
        >
      </div>
    </template>
  </dialogModel>
</template>

<script>
import dialogModel from "@/components/dialogModel.vue";
import {
  getEvaluation, //查看评价
  addEvaluation, //添加评价
} from "@/assets/api/ExternalLink";

export default {
  name: "EvaluationDialog",
  components: {
    dialogModel,
  },
  props: {
    VisibleEvaluation: {
      type: Boolean,
      default: false,
    },
    orderNumber: {
      type: String,
      default: "",
    },
    handleTypeName: {
      type: String,
      default: "",
    },
    businessTypeName: {
      type: String,
      default: "",
    },
    proxyId: {
      type: [String, Number],
      default: "",
    },
    evaluationMonth: {
      type: String,
      default: "",
    },
    // 被评价人（由父组件传入）
    evaluatedName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      textarea: "",
      value1: null,
      value2: null,
      value3: null,
      isEvaluated: false, //是否已评价
      data: {}, //评价数据
      companyName: "", //本企业名称
      linkId: "", // getEvaluation 返回的关联ID
    };
  },
  computed: {
    dialogTitle() {
      const name = this.evaluatedName == null ? "" : String(this.evaluatedName).trim();
      return name ? `评价（${name}）` : "评价";
    },
    commentDisplayText() {
      const text = this.textarea == null ? "" : String(this.textarea).trim();
      return text || "暂无评语";
    },
  },
  watch: {
    VisibleEvaluation(newVal) {
      if (newVal && (this.orderNumber || this.proxyId)) {
        this.resetForm();
        this.getCompanyName();
        this.getEvaluation();
      }
    },
  },
  methods: {
    resetForm() {
      this.textarea = "";
      this.value1 = null;
      this.value2 = null;
      this.value3 = null;
      this.isEvaluated = false;
      this.data = {};
      this.linkId = "";
    },
    // 获取本企业名称
    getCompanyName() {
      // 使用Vuex store中的公司信息
      const company = this.$store.getters.getCompany;
      if (company && company.name) {
        this.companyName = company.name;
      } else {
        this.companyName = "未知公司";
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit("handleCloseEvaluation");
    },
    // 星级 → 分数（半星步进：0.5→10 … 5→100）
    starToScore(star) {
      if (star == null || star === "" || Number(star) <= 0) return null;
      return Math.round(Number(star) * 20);
    },
    // 分数 → 星级
    scoreToStar(score) {
      if (score == null || score === "" || Number(score) <= 0) return null;
      return Number(score) / 20;
    },
    // 提交评价
    handelSb() {
      if (this.proxyId && !this.linkId) {
        this.$tool.PromptBox("warning", "缺少评价关联ID，请稍后重试");
        return;
      }
      var data = {
        data: {
          ...(this.proxyId
            ? {
                proxyId: this.proxyId,
                linkId: this.linkId, // 使用 getEvaluation 返回的 linkId
              }
            : { orderNumber: this.orderNumber }),
          technicalCapabilities: this.starToScore(this.value1), //技术能力
          responseSpeed: this.starToScore(this.value2), //响应速度
          serviceAttitude: this.starToScore(this.value3), // 服务态度
          comment: this.textarea, //评语
        },
      };
      console.log("提交的数据:", data);

      if (this.value1 && this.value2 && this.value3) {
        addEvaluation(data).then((res) => {
          if (res.data.code == 0) {
            this.$tool.PromptBox("success", "已提交");
            this.$emit("handleSuccess");
            this.handleClose();
          }
        });
      } else {
        this.$tool.PromptBox("warning", "评分不能为空");
      }
    },
    // 获取评价信息
    getEvaluation() {
      var data = {
        data: this.proxyId
          ? { proxyId: this.proxyId }
          : { orderNumber: this.orderNumber },
      };
      getEvaluation(data).then((res) => {
        if (res.data.code == 0 && res.data.data) {
          this.linkId = res.data.data.linkId || "";
          this.value1 = this.scoreToStar(res.data.data.technicalCapabilities);
          this.value2 = this.scoreToStar(res.data.data.responseSpeed);
          this.value3 = this.scoreToStar(res.data.data.serviceAttitude);
          this.textarea = res.data.data.comment;
          if (res.data.data.hasCommit == 1) {
            this.isEvaluated = true;
          } else {
            this.isEvaluated = false;
          }
          // 如果返回的数据中没有companyName，使用本企业名称
          this.data = {
            ...res.data.data,
            companyName: res.data.data.companyName || this.companyName,
            handleTypeName:
              res.data.data.handleTypeName ||
              res.data.data.handleType ||
              this.handleTypeName,
            businessTypeName:
              res.data.data.businessTypeNames ||
              res.data.data.businessTypeName ||
              res.data.data.businessType ||
              this.businessTypeName,
          };
        } else {
          // 没有评价数据时，使用本企业名称作为评价人，并设置服务类型和服务类别
          this.linkId = "";
          this.data = {
            companyName: this.companyName,
            handleTypeName: this.handleTypeName,
            businessTypeName: this.businessTypeName,
          };
          this.isEvaluated = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.evaluation-content {
  padding: 10px 40px 20px;
  .content-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    min-height: 32px;
    color: #303133;
    font-size: 14px;
    line-height: 22px;
  }
  .comment-item {
    align-items: flex-start;
  }
  .comment-label {
    flex-shrink: 0;
    line-height: 32px;
  }
  .textarea-box {
    flex: 1;
    min-width: 0;
    max-width: 420px;
  }
  .comment-text {
    flex: 1;
    min-width: 0;
    max-width: 420px;
    padding-top: 5px;
    color: #303133;
    line-height: 22px;
    white-space: pre-wrap;
    word-break: break-all;
  }
  /deep/ .textarea-lg {
    width: 100% !important;
  }
  /deep/ .textarea-lg .el-textarea__inner {
    min-height: 120px !important;
    height: 120px !important;
    line-height: 22px !important;
    padding: 10px 12px 28px !important;
    font-size: 14px;
    color: #303133;
  }
  /deep/ .textarea-lg .el-input__count {
    bottom: 8px !important;
    right: 12px !important;
    background: #fff !important;
    line-height: 1;
    z-index: 1;
  }
}
</style>
